import React from "react";
import { Loader2 } from "lucide-react";
import { apiTvwMasuk } from "@/lib/publicApi";
import { Logo } from "@/components/Logo";

// Owner 2026-10-16: one access code (made by the Owner in menu Layar Produksi) opens both the
// layar produksi (/monitoring/layar) and the shop TV (/tv). The device token is an HttpOnly cookie.
export function TvKode({ onMasuk, judul, pesan }) {
  const [kode, setKode] = React.useState("");
  const [nama, setNama] = React.useState("");  // v2.15: device name shown to the Owner (optional)
  const [error, setError] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const kirim = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    try { await apiTvwMasuk(kode, nama.trim()); onMasuk(); } catch (er) { setError(er.response?.data?.detail || "Gagal masuk. Coba lagi."); } finally { setBusy(false); }
  };
  return (
    <div data-testid="tvw-kode" className="flex min-h-screen items-center justify-center bg-soq-biru p-6">
      <form onSubmit={kirim} className="w-full max-w-lg space-y-4 rounded-2xl bg-white p-8 text-center shadow-xl">
        <Logo varian="hitam" className="mx-auto h-12 w-auto" />
        <h1 className="font-judul text-3xl uppercase text-soq-biru-tua">{judul}</h1>
        {pesan && <p data-testid="tvw-kode-pesan" className="rounded-lg border border-amber-400 bg-amber-50 px-3 py-2 text-base text-amber-800">{pesan}</p>}
        <p className="text-lg text-slate-600">Masukkan kode akses TV dari Owner (sekali saja di TV ini). Kode dibuat di menu Monitoring → Layar produksi &amp; kode TV; kode yang sama untuk TV depan dan layar produksi.</p>
        <input data-testid="tvw-kode-input" autoFocus value={kode} onChange={(e) => setKode(e.target.value.toUpperCase())} maxLength={20}
          className="w-full rounded-xl border-4 border-soq-biru px-4 py-3 text-center font-mono text-4xl tracking-[0.3em] text-slate-900" />
        <input data-testid="tvw-kode-nama" value={nama} onChange={(e) => setNama(e.target.value)} maxLength={60} placeholder="Nama perangkat (opsional), mis. TV ruang produksi / HP Budi"
          className="w-full rounded-xl border-2 border-slate-300 px-4 py-2 text-center text-lg text-slate-800" />
        {error && <p data-testid="tvw-kode-error" className="text-lg font-semibold text-red-600">{error}</p>}
        <button data-testid="tvw-kode-masuk" disabled={busy || !kode.trim()} className="w-full rounded-xl bg-soq-oranye py-4 text-2xl font-bold text-soq-biru-tua disabled:opacity-50">
          {busy ? <Loader2 className="inline animate-spin" /> : "Masuk"}</button>
      </form>
    </div>
  );
}
